import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FailContainer } from "./styled";

const Fail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const code = query.get("code") || "UNKNOWN_ERROR";
  const message = query.get("message") || "결제에 실패했습니다.";

  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      navigate("/shop/mypage/cart");
    }, 10000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <FailContainer>
      <strong className="tit">결제 실패</strong>
      <p>
        [코드] {code}
        <br />
        [메시지] {decodeURIComponent(message)}
      </p>
      <p>문제가 발생했습니다.</p>
      <p>
        <strong>{countdown}</strong>초 후 장바구니로 이동합니다.
      </p>
      <p>
        문제가 계속된다면{" "}
        <a href="/shop/help" style={{ color: "#007bff", textDecoration: "underline" }}>
          고객센터
        </a>
        에 문의해주세요.
      </p>
    </FailContainer>
  );
};

export default Fail;
